export default "__VITE_ASSET__okiKHA4a__"